export const GET_ROLE = `GET_ROLE`;
export const SET_ROLE = `SET_ROLE`;
export const GET_APIMKEY=`GET_APIMKEY`
export const SET_APIMKEY=`SET_APIMKEY`
export const SET_STEP1_STATUS = `SET_STEP1_STATUS`;
export const SET_STEP2_STATUS = `SET_STEP2_STATUS`;
export const SET_STEP3_STATUS = `SET_STEP3_STATUS`;
export const SET_STEP3_SKIP = `SET_STEP3_SKIP`;
export const SET_STAGE = `SET_STAGE`;
export const SET_CANCEL = `SET_CANCEL`;
export const VALIDATE_EMPLOYEE_ID = `VALIDATE_EMPLOYEE_ID`;
export const SET_EMPLOYEE_VALIDATIONDATA = `SET_EMPLOYEE_VALIDATIONDATA`;
export const EMPLOYEE_VALIDATION_SUCCESS = `EMPLOYEE_VALIDATION_SUCCESS`;
export const EMPLOYEE_VALIDATION_ERROR = `EMPLOYEE_VALIDATION_ERROR`;
export const RESET_EMPLOYEE_DATA = `RESET_EMPLOYEE_DATA`;

export const GET_CARD_NUMBER = `GET_CARD_NUMBER`;
export const SET_CARD_NUMBER_DATA = `SET_CARD_NUMBER_DATA`;
export const SAVE_EMPLOYEE_ACCOUNT_FORM_SUCCESS_MESSAGE = `SAVE_EMPLOYEE_ACCOUNT_FORM_SUCCESS_MESSAGE`;
export const SAVE_EMPLOYEE_ACCOUNT_FORM_WARNING_MESSAGE = `SAVE_EMPLOYEE_ACCOUNT_FORM_WARNING_MESSAGE`;
export const SAVE_EMPLOYEE_ACCOUNT_FORM_INFO_MESSAGE = `SAVE_EMPLOYEE_ACCOUNT_FORM_INFO_MESSAGE`;
export const SAVE_EMPLOYEE_ACCOUNT_FORM_ERROR_MESSAGE = `SAVE_EMPLOYEE_ACCOUNT_FORM_ERROR_MESSAGE`;
export const ACCOUNT_FIELD_SELECT_ERROR = `ACCOUNT_FIELD_SELECT_ERROR`;

export const GET_OTP = `GET_OTP`;
export const IS_FIRST_OTP_SEND = `IS_FIRST_OTP_SEND`;
export const SAVE_EMPLOYEE_GET_OTP_FORM_SUCCESS_MESSAGE = `SAVE_EMPLOYEE_GET_OTP_FORM_SUCCESS_MESSAGE`;
export const SAVE_EMPLOYEE_GET_OTP_FORM_ERROR_MESSAGE = `SAVE_EMPLOYEE_GET_OTP_FORM_ERROR_MESSAGE`;

export const SET_OTP = `SET_OTP`;
export const VALIDATE_OTP = `VALIDATE_OTP`;
export const SAVE_EMPLOYEE_OTP_FORM_SUCCESS_MESSAGE = `SAVE_EMPLOYEE_OTP_FORM_SUCCESS_MESSAGE`;
export const SAVE_EMPLOYEE_OTP_FORM_ERROR_MESSAGE = `SAVE_EMPLOYEE_OTP_FORM_ERROR_MESSAGE`;


export const GET_ZIPCODE = `GET_ZIPCODE`;
export const SET_OPTIONAL_FORM_DATA = `SET_OPTIONAL_FORM_DATA`;
export const SET_ZIPCODE = `SET_ZIPCODE`;
export const ZIPCODE_SUCCESS_MESSAGE = `ZIPCODE_SUCCESS_MESSAGE`;
export const ZIPCODE_ERROR_MESSAGE = `ZIPCODE_ERROR_MESSAGE`;
export const RESET_ZIPCODE = `RESET_ZIPCODE`;
export const SAVE_EMPLOYEE_DISCOUNT_FORM = `SAVE_EMPLOYEE_DISCOUNT_FORM`;
export const SAVE_EMPLOYEE_DISCOUNT_FORM_SUCCESS_MESSAGE = `SAVE_EMPLOYEE_DISCOUNT_FORM_SUCCESS_MESSAGE`;
export const SAVE_EMPLOYEE_DISCOUNT_FORM_ERROR_MESSAGE = `SAVE_EMPLOYEE_DISCOUNT_FORM_ERROR_MESSAGE`;
export const SAVE_EMPLOYEE_DISCOUNT_FORM_INFO_MESSAGE = `SAVE_EMPLOYEE_DISCOUNT_FORM_INFO_MESSAGE`;

export const GET_ACCESSDETAILS=`GET_ACCESSDETAILS`
export const SET_ACCESSDETAILS=`SET_ACCESSDETAILS`
export const SET_TOTAL_ATTEMPT=`SET_TOTAL_ATTEMPT`


export const getRole = () => ({
    type: GET_ROLE,
});

export const setRole = (data) => ({
    type: SET_ROLE,
    value: data,
});
export const isFirstOtpSend = (data) => ({
    type: IS_FIRST_OTP_SEND,
    value: data,
});
export const setStep3Skip = (data) => ({
    type: SET_STEP3_SKIP,
    value: data,
});
export const setTotalAttempt = (data) => ({
    type: SET_TOTAL_ATTEMPT,
    value: data,
});

export const getAccessDetails =(userInfo)=>({
    type:GET_ACCESSDETAILS,
    value:userInfo
})

export const setAccessDetails =(data)=>({
    type:SET_ACCESSDETAILS,
    value:data
})

export const setStep1Status = (data) => ({
    type: SET_STEP1_STATUS,
    value: data,
});

export const setStep2Status = (data) => ({
    type: SET_STEP2_STATUS,
    value: data,
});

export const setStep3Status = (data) => ({
    type: SET_STEP3_STATUS,
    value: data,
});

export const getAPIMKey =()=>({
    type:GET_APIMKEY
})

export const setAPIMKey =(data,url)=>({
    type:SET_APIMKEY,
    value:data,
    url:url,
})

export const setCancel = (input) => ({
    type: SET_CANCEL,
    value: input,
});
export const setStage = (stage) => ({
    type: SET_STAGE,
    value: stage,
});

// for step1 actions
export const getEmployeeIdData = (employeeID) => ({
    type: VALIDATE_EMPLOYEE_ID,
    payload: employeeID,
});

export const setEmployeeValidationData = (data) => ({
    type: SET_EMPLOYEE_VALIDATIONDATA,
    value: data,
});
export const resetEmployeeValidationData = (step,keyToReset) => ({
    type: RESET_EMPLOYEE_DATA,
    step: step,
    keyToReset: keyToReset,
});

export const setEmployeeValidationSucessMessage = (successMsg) => ({
    type: EMPLOYEE_VALIDATION_SUCCESS,
    value: successMsg,
});

export const setEmployeeValidationErrorMessage = (error) => ({
    type: EMPLOYEE_VALIDATION_ERROR,
    value: error,
});

// for step2 actions
export const getCardNumberData = (cardNumber, empId) => ({
    type: GET_CARD_NUMBER,
    payload: {cardNumber:cardNumber, empId:empId} ,
});

export const setCardNumberData = (data) => ({
    type: SET_CARD_NUMBER_DATA,
    value: data,
});


export const setEmployeeAccountSuccessMessage = (success) => ({
    type: SAVE_EMPLOYEE_ACCOUNT_FORM_SUCCESS_MESSAGE,
    value: success,
});

export const setEmployeeAccountWarningMessage = (success) => ({
    type: SAVE_EMPLOYEE_ACCOUNT_FORM_WARNING_MESSAGE,
    value: success,
});
export const setEmployeeAccountInfoMessage = (success) => ({
    type: SAVE_EMPLOYEE_ACCOUNT_FORM_INFO_MESSAGE,
    value: success,
});
export const setEmployeeDiscountFormInfoMessage = (success) => ({
    type: SAVE_EMPLOYEE_DISCOUNT_FORM_INFO_MESSAGE,
    value: success,
});
export const setEmployeeAccountErrorMessage = (error) => ({
    type: SAVE_EMPLOYEE_ACCOUNT_FORM_ERROR_MESSAGE,
    value: error,
});

// step 3

export const getOTP = (data) => ({
    type: GET_OTP,
    payload: data,
});

export const validateOtp = (data) => ({
    type: VALIDATE_OTP,
    payload: data,
});

export const setOtpData = (data) => ({
    type: SET_OTP,
    value: data,
});

export const setEmployeeOtpSuccessMessage = (success) => ({
    type: SAVE_EMPLOYEE_OTP_FORM_SUCCESS_MESSAGE,
    value: success,
});
export const setEmployeeOtpErrorMessage = (error) => ({
    type: SAVE_EMPLOYEE_OTP_FORM_ERROR_MESSAGE,
    value: error,
});
export const setEmployeeGetOtpSuccessMessage = (success) => ({
    type: SAVE_EMPLOYEE_GET_OTP_FORM_SUCCESS_MESSAGE,
    value: success,
});
export const setEmployeeGetOtpErrorMessage = (error) => ({
    type: SAVE_EMPLOYEE_GET_OTP_FORM_ERROR_MESSAGE,
    value: error,
});

// step 4

export const getZipCodeData = (zipCode) => ({
    type: GET_ZIPCODE,
    payload: zipCode,
});

export const setZipCodeData = (data) => ({
    type: SET_ZIPCODE,
    value: data,
});
export const saveEmployeeDiscountForm = (data,input) => ({
    type: SAVE_EMPLOYEE_DISCOUNT_FORM,
    payload: data,
    value:input
});
export const resetZipCode = () => ({
    type: RESET_ZIPCODE,
});

export const setZipCodeErrorMessage = (error) => ({
    type: ZIPCODE_ERROR_MESSAGE,
    value: error,
});
export const setZipCodeSuccessMessage = (success) => ({
    type: ZIPCODE_SUCCESS_MESSAGE,
    value: success,
});

export const setEmployeeDiscountFormErrorMessage = (error) => ({
    type: SAVE_EMPLOYEE_DISCOUNT_FORM_ERROR_MESSAGE,
    value: error,
});
export const setEmployeeDiscountFormSuccessMessage = (success) => ({
    type: SAVE_EMPLOYEE_DISCOUNT_FORM_SUCCESS_MESSAGE,
    value: success,
});

export const setOptionalFormData = (data) => ({
    type: SET_OPTIONAL_FORM_DATA,
    value: data,
});
